import React, { useState } from 'react'
import classNames from 'classnames'
import ActionBoxRowCell from './ActionBoxRowCell'
import ActionBoxRowButton from './ActionBoxRowButton'
import './ActionBoxRowItem.scss'

const ActionBoxRowItem = ({ rowClick, cellDefs, action, color, row, isDisabled, isLastRow, hoverActions = [], isExpanded, expandedActions = [], isSelected }) => {
  const [itemHover, toggleItemHover] = useState(false)
  const [activeActionMenu, setActiveActionMenu] = useState(false)
  const isExpandable = row.expandedContent || expandedActions.length > 0

  return (
    <>
      <div
        className={classNames(
          'viso-action-box-row-item',
          rowClick && 'viso-action-box-row-item--clickable',
          isLastRow && 'viso-action-box-row-item--last',
          action && 'viso-action-box-row-item--action',
          isDisabled && 'viso-action-box-row-item--disabled',
          isExpanded && 'viso-action-box-row-item--expanded',
          isSelected && 'viso-action-box-row-item--selected',
          isExpandable && !isExpanded && 'viso-text-label'
        )}
        onMouseEnter={() => !isDisabled && toggleItemHover(true)}
        onMouseLeave={() => !isDisabled && !activeActionMenu && toggleItemHover(false)}
        onClick={() => rowClick && rowClick(row)}
      >
        {cellDefs.map((def, index) => (
          <ActionBoxRowCell
            key={index}
            def={def}
            row={row}
            itemHover={itemHover}
            isDisabled={isDisabled}
            isLastRow={isLastRow}
            isExpanded={isExpanded}
            isSelected={isSelected}
          />
        ))}
        {hoverActions.length > 0 &&
          <div className={classNames(
            'viso-action-box-row-item__hover-actions',
            itemHover && 'viso-action-box-row-item__hover-actions--visible',
            action && 'viso-action-box-row-item__hover-actions--offset'
          )}>
            {hoverActions.map((action, index) => (
              <ActionBoxRowButton
                key={index}
                action={action}
                color={color}
                row={row}
                itemHover={itemHover}
                isDisabled={isDisabled}
                isLastRow={isLastRow}
                isHoverAction
                isExpanded={isExpanded}
                isSelected={isSelected}
              />
            ))}
          </div>
        }
        {action &&
          <ActionBoxRowButton
            action={action}
            color={color}
            row={row}
            itemHover={itemHover}
            isDisabled={isDisabled}
            isLastRow={isLastRow}
            isExpanded={isExpanded}
            isSelected={isSelected}
            onClickMenu={(isMenuActive) => {
              setActiveActionMenu(isMenuActive)
              if(!isMenuActive && itemHover) {
                toggleItemHover(false)
              }
            }}
          />
        }
      </div>
      {isExpanded && (
        <div className='viso-action-box-row-item__expanded'>
          {row.expandedContent}
          {expandedActions.length > 0 &&
            <div className='viso-action-box-row-item__actions'>
              {expandedActions.map((action, index) => (
                <button
                  key={index}
                  className={classNames(
                    'viso-action-box-row-item__action',
                    action.plain && `viso-action-box-row-item__action--plain-${action.plain}`,
                    action.light && `viso-action-box-row-item__action--light-${action.light}`
                  )}
                  onClick={() => action.onClick && action.onClick(row)}
                >
                  {action.label}
                </button>
              ))}
            </div>
          }
        </div>
      )}
    </>
  )
}

export default ActionBoxRowItem